import React from 'react';

const Hero: React.FC = () => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  const handleStartPracticing = () => {
    // Add a small delay to allow Google to crawl the page
    setTimeout(() => {
      window.location.href = 'https://app.choralplayer.com';
    }, 100);
  };

  return (
    <section className="relative overflow-hidden bg-[#081D30] min-h-[88vh] flex flex-col justify-center px-4 pt-16">
      {/* Glow orbs — top right */}
      <div className="pointer-events-none absolute -top-32 -right-32 w-[500px] h-[500px] rounded-full bg-blue-500 opacity-[0.12] blur-[120px] animate-glow-drift-1" />
      <div className="pointer-events-none absolute top-10 right-10 w-72 h-72 rounded-full bg-blue-400 opacity-[0.10] blur-[80px] animate-glow-drift-2" />
      <div className="pointer-events-none absolute top-32 right-48 w-40 h-40 rounded-full bg-sky-400 opacity-[0.08] blur-[60px] animate-glow-drift-3" />
      {/* Glow orbs — bottom left */}
      <div className="pointer-events-none absolute -bottom-32 -left-32 w-[500px] h-[500px] rounded-full bg-blue-500 opacity-[0.10] blur-[120px] animate-glow-drift-4" />
      <div className="pointer-events-none absolute bottom-16 left-16 w-64 h-64 rounded-full bg-blue-400 opacity-[0.08] blur-[80px] animate-glow-drift-5" />

      <div className="relative container mx-auto text-center py-16">
        <div className="max-w-4xl mx-auto">
          {/* Logo lockup */}
          <div className="flex items-center justify-center gap-3 mb-8 animate-fade-up" style={{ animationDelay: '0ms' }}>
            <img
              src="/Logo.svg"
              alt="ChoralPlayer icon"
              className="h-12 w-12"
              style={{ filter: 'brightness(0) invert(1)' }}
            />
            <span className="text-3xl font-bold text-white tracking-tight">ChoralPlayer</span>
          </div>

          {/* Main Headline */}
          <h1 className="text-5xl md:text-6xl font-bold mb-14 animate-fade-up" style={{ animationDelay: '120ms' }}>
            <span className="text-white">Practice made</span>
            <span className="text-white"> powerful.</span>
          </h1>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-20 animate-fade-up" style={{ animationDelay: '240ms' }}>
            <button onClick={handleStartPracticing} className="btn btn-primary text-lg px-8 py-4 min-w-[220px]">
              Start Practicing Now
            </button>
            <button
              onClick={() => scrollToSection('features')}
              className="btn btn-secondary text-lg px-8 py-4 min-w-[220px]"
            >
              See How It Works
            </button>
          </div>

          {/* Feature Highlights */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto animate-fade-up" style={{ animationDelay: '400ms' }}>
            <div className="card text-center">
              <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-blue-700 rounded-lg flex items-center justify-center mx-auto mb-4">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
                </svg>
              </div>
              <h3 className="font-semibold mb-2">Any Device</h3>
              <p className="text-gray-600 text-sm">Access from phone, tablet, or computer</p>
            </div>
            
                         <div className="card text-center">
               <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-blue-700 rounded-lg flex items-center justify-center mx-auto mb-4">
                 <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                 </svg>
               </div>
               <h3 className="font-semibold mb-2">Custom Built</h3>
               <p className="text-gray-600 text-sm">Every single track on ChoralPlayer is hand-crafted in house</p>
             </div>
            
            <div className="card text-center">
              <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-blue-700 rounded-lg flex items-center justify-center mx-auto mb-4">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.536 8.464a5 5 0 010 7.072m2.828-9.9a9 9 0 010 12.728M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z" />
                </svg>
              </div>
              <h3 className="font-semibold mb-2">Part Muting</h3>
              <p className="text-gray-600 text-sm">Practice with or without other voices</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero; 